// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import SpinePlayer from '../../../../components/SpinePlayer';
import theme from '../../../../styled-components/dark';
import { SpineAnimationIds } from '../../../../types/animations';
import { SoundIds } from '../../../../types/sounds';

const Text = styled.div`
  margin-top: 3em;

  font-size: 1em;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
`;

const HighlightText = styled.span`
  color: ${theme.KLNotification.highlightColor};
`;

const SpinePlayerWrapper = styled.div`
  width: 100%;
  margin-top: -1.5em;
  padding-bottom: 120%;
`;

const KLNotificationCollar = () => {
  return (
    <>
      <Text>
        Vous jouez votre <HighlightText>collier</HighlightText> !<br />
        Vous pouvez continuer l&apos;aventure.
      </Text>
      <SpinePlayerWrapper>
        <SpinePlayer animationId={SpineAnimationIds.KL_COLLAR_USED} soundId={SoundIds.KL_COLLAR_USED} scale={0.35} />
      </SpinePlayerWrapper>
    </>
  );
};

export default KLNotificationCollar;
